import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroupDirective, NgForm, Validators, FormGroup } from '@angular/forms';
import { UIRouter } from '@uirouter/angular';
import { ApiService } from '../api.service';

@Component({
  selector: 'mea-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  public badCredentials: boolean;
  working: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    // private userService: UserService,
    private router: UIRouter) {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
    this.badCredentials = false;
  }

  ngOnInit() {
  }

  onSubmit({ email, password }: { email: string, password: string }) {
    this.badCredentials = false;
    this.working = true;
    this.apiService.login(email, password).subscribe({
      next: (response) => {
        const token = response.jwt;
        if (token) {
          localStorage.setItem('token', token);
          // this.userService.email = email;
          this.loginForm.reset();
          this.router.stateService.go('home');
        } else {
          this.badCredentials = true;
          this.working = false;
        }
      },
      error: (error) => {
        if (error.status === 401) {
          this.badCredentials = true;
          this.working = false;
        } else {
          // server down?
          console.error('Login error:', error);
          this.working = false;
        }
      }
    });
  }

  getErrorMessage(field) {
    const control = this.loginForm.get(field);
    return control.hasError('required') ? 'שדה חובה' :
      control.hasError('email') ? 'כתובת אימייל לא חוקית' :
        '';
  }

}
